import { Registration } from "src/domain/entities/registration"
import { Gender, MaritalStatus } from "src/utils/enums"
import { MultiLangText } from "src/utils/types"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
	update: {
		firstName?: MultiLangText
		subCasteId?: string
		surnameId?: string
		surnameText?: MultiLangText
		gender?: Gender
		dateOfBirth?: number
		maritalStatus?: MaritalStatus
	}
}

export async function registrationBasicUpdateApi(
	payload: RequestDataShape,
	token?: null | string,
) {
	const endpoint = "/registration/basic/update/v1"
	const requester = new ApiRequester<RequestDataShape, Registration>(endpoint)
	return await requester.sendRequest(payload, token)
}
